import React from "react";

import FormControl from "@mui/material/FormControl";
import _ from "lodash";

import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

export default function Select({ register, ...props }) {
  return (
    <>
      <FormControl fullWidth>
        <Autocomplete
          disableClearable={props.disableClearable}
          name={props.name}
          options={props.options}
          value={props.value}
          onChange={props.onChange}
          getOptionLabel={(item) => (item.label ? item.label : "")}
          // getOptionSelected={(option, value) =>
          //   value === undefined || value === "" || option.id === value.id
          // }
          isOptionEqualToValue={(option, value) => {
            if (option === value) {
              return true;
            }
            if (!option || !value) {
              return false;
            }
            if (option.id !== undefined && value.id !== undefined) {
              return option.id === value.id;
            }
            if (typeof option !== typeof value) {
              return false;
            }
            if (option.value !== undefined && value.value !== undefined) {
              if (typeof option.value !== typeof value.value) {
                return false;
              }
              if (typeof option.value !== "object") {
                return option.value === value.value;
              }
              return _.isEqual(option.value, value.value);
            }
            return false;
          }}
          renderInput={(params) => (
            <TextField
              placeholder={props.placeholder}
              {...params}
              label={props.label}
              required={props.required}
              color={props.color}
              sx={{
                backgroundColor: props.backgroundColor,

                "& .MuiOutlinedInput-root:hover": {
                  "& > fieldset": {
                    borderColor: props.hoverColor,
                  },
                },
                "& fieldset": {
                  borderColor: props.fieldsetBorderColor,
                },
              }}
            />
          )}
        />
      </FormControl>
    </>
  );
}
